module.exports = __webpack_public_path__ + "img/eqBg1.bcad20a0.png";